<template>
  <div>
    Address:
    <a
      v-if="currency == 'BTC'"
      v-bind:href="'https://btc1.trezor.io/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else-if="currency == 'BCH'"
      v-bind:href="'https://bch1.trezor.io/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else-if="currency == 'DOGE'"
      v-bind:href="'https://doge1.trezor.io/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else-if="currency == 'LTC'"
      v-bind:href="'https://ltc1.trezor.io/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else-if="ccurrency == 'ETH'"
      v-bind:href="'https://etherscan.io/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else-if="currency == 'TRX'"
      v-bind:href="'https://tronscan.org/#/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else-if="
        currency == 'BNB' ||
          currency == 'BUSD' ||
          currency == 'USDT' ||
          currency == 'GG' ||
          currency == 'BSC-USD'
      "
      v-bind:href="'https://bscscan.com/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else-if="address.slice(0, 2) == '0x'"
      v-bind:href="'https://etherscan.io/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
    <a
      v-else
      v-bind:href="'https://tronscan.org/#/address/' + address"
      target="_blank"
      >{{ address.slice(0, 10) }}...{{ address.slice(-10) }}
      <i class="fad fa-external-link-alt m-r-xs"></i
    ></a>
  </div>
</template>

<script>
export default {
  props: ["currency", "address"],
};
</script>
